import { Component } from 'react';
import Header from '../../../Header'
import MessageLink from '../../../MessageLink';
import Footer from '../../../Footer';
import Patrimonio from '../../../Numeros/Patrimonio';
import Beneficios from '../../../Numeros/Beneficios';
import Vidas from '../../../Numeros';
import Lgpd from '../../../Lgpd';
import ErrorBoundary from '../../../ErrorHandler/ErrorBoundary';
import InfoComponent from '../../InfoComponent';

class Numeros extends Component {
	render() {
		return (
			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>

				<InfoComponent image={"numeros"} page={'numeros'}></InfoComponent>		

				{/* Content page */}
				<div className="_the-content page-numeros pb-10">
					<div className="container">
						<ErrorBoundary><Patrimonio /></ErrorBoundary>
						<div className="col-lg-10">
							<ErrorBoundary><Vidas /></ErrorBoundary>
							<ErrorBoundary><Beneficios /></ErrorBoundary>
						</div>
					</div>
				</div>
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>

			</div>
		);
	}
};

export default Numeros;